/* AxeHouseCraft: progressive enhancement; every collection is visible without JS. */
if (!customElements.get('ahc-collection-tabs')) {
  customElements.define('ahc-collection-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const tablist = this.querySelector('[data-ahc-tabs]');
      const tabs = [...this.querySelectorAll('[data-ahc-tab]')];
      const panels = [...this.querySelectorAll('[data-ahc-panel]')];
      if (!tablist || !tabs.length || tabs.length !== panels.length) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      this.cleanup = () => controller.abort();
      this.activate = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      };
      tablist.setAttribute('role', 'tablist');
      tabs.forEach((tab, i) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[i].id);
        panels[i].setAttribute('role', 'tabpanel');
        panels[i].setAttribute('aria-labelledby', tab.id);
        panels[i].tabIndex = 0;
        tab.addEventListener('click', event => { event.preventDefault(); this.activate(i); }, options);
        tab.addEventListener('keydown', event => {
          const rtl = getComputedStyle(this).direction === 'rtl';
          const direction = rtl ? -1 : 1;
          let next;
          if (event.key === 'ArrowRight') next = (i + direction + tabs.length) % tabs.length;
          if (event.key === 'ArrowLeft') next = (i - direction + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (event.key === ' ') next = i;
          if (next === undefined) return;
          event.preventDefault(); this.activate(next, true);
        }, options);
      });
      this.classList.add('ahc-tabs-ready');
      this.activate(0);
      document.addEventListener('shopify:block:select', event => {
        const index = panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
        if (index >= 0 && this.contains(event.target)) this.activate(index);
      }, options);
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
  });
}
